import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
// const SOCKET_URL = "ws://localhost:3506";

const socket = io(SOCKET_URL, {
  path: "/socket.io/",
  transports: ["websocket"],
  // autoConnect: false
});

socket.on("connect", () => {
  console.info("Socket connected:", socket.id);
});

export const createSocketUser = userId => {
  socket.emit("subscribe", userId);
};

export const deleteSocketUser = userId => {
  socket.emit("unSubscribe", userId);
};

// socket.disconnect()

export default socket;

